import React from "react";

import EngageWidgetCard from "./EngageWidgetCard";
import { WidgetOfferManager } from "../managers";

const EngageWidget = () => {
    return (
        <WidgetOfferManager>
            <EngageWidgetCard />
        </WidgetOfferManager>
    )
};

export default EngageWidget;
